import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react'
import { logout } from '../../api/axiosAuthorization'
import avatarIcon from '../../assets/icons/avatar.png'

export const UserAvatar = () => {
  return (
    <div className="mx-2">
      <Dropdown
        classNames={{
          base: 'bg-white rounded-xl',
          content: 'bg-white rounded-xl border border-tdpllightgrey border-opacity-60',
        }}
      >
        <DropdownTrigger>
          <button
            type="button"
            className="flex items-center justify-center w-[1.5rem] h-[1.5rem] rounded-full overflow-hidden cursor-pointer hover:opacity-80 transition-opacity focus:outline-none p-0 m-0 border-0"
            aria-label="User menu"
          >
            <img
              src={avatarIcon}
              alt="User Avatar"
              className="w-full h-full object-cover scale-110"
              onError={(e) => {
                // Hide broken image and show fallback icon
                e.currentTarget.style.display = 'none'
                const parent = e.currentTarget.parentElement
                if (parent && !parent.querySelector('svg')) {
                  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
                  svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg')
                  svg.setAttribute('fill', 'none')
                  svg.setAttribute('viewBox', '0 0 24 24')
                  svg.setAttribute('stroke-width', '1.5')
                  svg.setAttribute('stroke', 'currentColor')
                  svg.setAttribute('class', 'w-3 h-3 text-tdpldarkgrey')

                  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
                  path.setAttribute('stroke-linecap', 'round')
                  path.setAttribute('stroke-linejoin', 'round')
                  path.setAttribute('d', 'M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z')

                  svg.appendChild(path)
                  parent.appendChild(svg)
                }
              }}
            />
          </button>
        </DropdownTrigger>
        <DropdownMenu aria-label="profile" variant="flat">
          <DropdownItem
            startContent
            className="text-tdplmaroon"
            key="logout"
            color="danger"
            onClick={logout}
          >
            Log Out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}
